import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, Grid, GridItem } from '@chakra-ui/react';
import React from 'react';
import { CheckboxMenu } from '../../components/checkbox-menu/checkbox-menu';
import { DatePickerComponent } from '../../components/datepicker-component/datepicker-component';
import { Button } from '../../components/button/button';
import { ButtonVariant } from '../../core/enums';
import { useDispatch } from 'react-redux';
import { applyDateFilter, applyFilters } from '../../actions/cases.action';
import { cmxDateTime, commonEnums as enums } from '@codametrix/ui-common';
import { styles } from './pop-up-filtersV2.styles';
import './pop-up-filtersV2.scss';
import { Select } from '../../components/select/select';
import { applyFilters as applyDictionaryFilters } from '../../actions/dictionary-values';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const { FilterTypes } = enums;
const PopUpFiltersV2 = ({ activeOrgId, clearFilters, criteriaFilter, isCases, setFilterableOptions, sortablePageable, getDictionary = (categoryParams)=>{}, getStatuses = (categoryParams)=>{}, getTenants = ()=>{} })=>{
    const classes = styles();
    const dispatch = useDispatch();
    const iconMapper = (categoryKey)=>{
        switch(categoryKey){
            case 'tenant_id':
                return /*#__PURE__*/ _jsx(BiomeIcon, {
                    iconName: IconName.Location,
                    iconSize: "16",
                    titleText: "Tenant",
                    iconClass: "form-icon"
                });
            case 'customer_phase':
                return /*#__PURE__*/ _jsx(BiomeIcon, {
                    iconName: IconName.Grid,
                    iconSize: "16",
                    titleText: "Phase",
                    iconClass: "form-icon"
                });
            default:
                return /*#__PURE__*/ _jsx(BiomeIcon, {
                    iconName: IconName.Check_Circle,
                    iconSize: "16",
                    titleText: "Status",
                    iconClass: "form-icon"
                });
        }
    };
    const hasMultipleFilters = criteriaFilter?.filterForms?.length > 1;
    const handleFilterCategoryClick = (categoryIndex)=>{
        switch(categoryIndex){
            case 'procedure_type_category':
                getDictionary({
                    categoryName: 'Procedure Type Categories',
                    key: 'procedure_type_category'
                });
                break;
            case 'case_status':
                getStatuses({
                    categoryName: 'casestatus',
                    key: 'case_status'
                });
                break;
            case 'tenant_code':
                getTenants(activeOrgId);
                break;
        }
    };
    const handleFilterSubmit = (key, selectedOptions)=>{
        var state = {
            key
        };
        let filters = [];
        if (criteriaFilter.filters) {
            filters = criteriaFilter.filters.filter((filter)=>{
                return filter.type !== 'GREATER_THAN_EQUAL' && filter.type !== 'LESS_THAN_EQUAL';
            }).filter((filter)=>{
                return filter.key !== state.key;
            });
        }
        let newFilter;
        let terms = [];
        let keyName;
        const keys = Object.keys(state);
        keys.forEach((key)=>{
            if (key !== 'key') {
                if (state[key] === true) {
                    terms.push(key);
                }
            } else {
                keyName = state[key];
            }
            terms = [];
            selectedOptions.forEach((option)=>{
                terms.push(option.value);
            });
            if (keyName !== undefined) {
                newFilter = {
                    key: keyName,
                    terms: terms,
                    type: FilterTypes.IN
                };
                if (terms.length !== 0) {
                    filters.push(newFilter);
                }
                setFilterableOptions && setFilterableOptions({
                    dateFilter: criteriaFilter.dateFilter ?? sortablePageable.filterableOptions.dateFilter,
                    filters
                });
                dispatch(applyFilters(filters));
            }
        });
    };
    const handleDateFilterSubmit = (startDate, endDate, filterKey)=>{
        let newFilter;
        if (startDate && endDate) {
            newFilter = {
                key: filterKey,
                from: cmxDateTime.format(startDate.toISOString(), cmxDateTime.FORMATS.DATE),
                to: cmxDateTime.format(endDate.toISOString(), cmxDateTime.FORMATS.DATE),
                type: FilterTypes.BETWEEN
            };
        } else {
            newFilter = undefined;
        }
        const filterSource = criteriaFilter.filters ?? sortablePageable.filterableOptions.filters ?? [];
        const nextFilters = filterSource.filter((filter)=>{
            return filter.type !== 'GREATER_THAN_EQUAL' && filter.type !== 'LESS_THAN_EQUAL';
        });
        setFilterableOptions && setFilterableOptions({
            dateFilter: newFilter,
            filters: nextFilters
        });
        dispatch(applyDateFilter(newFilter));
    };
    const handleSelectFilterSubmit = (event, form)=>{
        const target = event.currentTarget;
        let filters = [];
        filters = criteriaFilter.filters.filter((filter)=>{
            return filter.type !== 'GREATER_THAN_EQUAL' && filter.type !== 'LESS_THAN_EQUAL';
        }).filter((filter)=>{
            return filter.key !== form.key;
        });
        let filterType = FilterTypes.IN;
        if (form.formDefinition.fieldGroups?.length) {
            filterType = form.formDefinition.fieldGroups[0].fields.find((field)=>field.key === target.value)?.filterType || filterType;
        }
        const newFilter = {
            key: form.key,
            terms: [
                target.value
            ],
            type: filterType
        };
        filters.push(newFilter);
        setFilterableOptions && setFilterableOptions({
            dateFilter: criteriaFilter.dateFilter ?? sortablePageable.filterableOptions.dateFilter,
            filters
        });
        if (target.value) {
            dispatch(applyDictionaryFilters(target.value));
        } else {
            dispatch(applyDictionaryFilters(''));
        }
    };
    const getCheckboxItems = (items)=>{
        return items?.map((item)=>{
            return {
                label: item.helpText ?? '',
                value: item.key ?? '',
                children: item.children
            };
        });
    };
    const filterDropdowns = criteriaFilter?.filterForms.filter((form)=>{
        return !form.disabled;
    }).map((form, index)=>{
        if (form.isExtra) {
            let selected = [];
            if (form.formDefinition.fieldGroups) {
                form.formDefinition.fieldGroups[0].fields?.[0]?.children?.forEach((field)=>{
                    criteriaFilter?.filters?.find((filter)=>{
                        return filter.key === form.key;
                    })?.terms.forEach((term)=>{
                        term === field.key && selected.push(field);
                    });
                });
            }
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(GridItem, {
                        children: /*#__PURE__*/ _jsx(Divider, {
                            orientation: "vertical",
                            sx: classes['.divider']
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        id: form.key,
                        onClick: ()=>!form?.formDefinition?.fieldGroups?.[0]?.fields?.length && handleFilterCategoryClick(form.key),
                        "data-testid": "extraFilter",
                        children: /*#__PURE__*/ _jsx(CheckboxMenu, {
                            options: (form?.formDefinition?.fieldGroups?.[0]?.fields && getCheckboxItems(form.formDefinition.fieldGroups[0].fields)) ?? [],
                            label: form.name,
                            onApplyFilters: (selectedOptions)=>{
                                handleFilterSubmit(form.key, selectedOptions);
                            },
                            selectedOptions: getCheckboxItems(selected) ?? [],
                            menuIcon: iconMapper(form.key),
                            isTree: true
                        })
                    }, form.name)
                ]
            });
        }
        if (form.isDate) {
            let startDate = new Date(cmxDateTime.format(criteriaFilter?.dateFilter?.from, cmxDateTime.FORMATS.DATE));
            let endDate = new Date(cmxDateTime.format(criteriaFilter?.dateFilter?.to, cmxDateTime.FORMATS.DATE));
            // Fixing display date off by 1
            startDate.setDate(startDate.getDate() + 1);
            endDate.setDate(endDate.getDate() + 1);
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(GridItem, {
                        children: /*#__PURE__*/ _jsx(Divider, {
                            orientation: "vertical",
                            sx: classes['.divider']
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        width: "185px",
                        children: /*#__PURE__*/ _jsx(DatePickerComponent, {
                            startDate: criteriaFilter?.dateFilter?.to ? startDate : null,
                            endDate: criteriaFilter?.dateFilter?.from ? endDate : null,
                            onSelection: (startDate, endDate)=>{
                                startDate && endDate && handleDateFilterSubmit(startDate, endDate, form.key);
                            },
                            iconLeft: /*#__PURE__*/ _jsx(BiomeIcon, {
                                iconName: IconName.Calendar,
                                iconClass: "form-icon",
                                iconSize: "16",
                                titleText: "Date Icon"
                            }),
                            showActiveBackground: isCases
                        })
                    })
                ]
            });
        }
        if (form.isSelect === true) {
            let defaultVal = '';
            if (form.formDefinition.fieldGroups) {
                form.formDefinition.fieldGroups.forEach((group)=>{
                    group.fields.forEach((field)=>{
                        const filterMatch = criteriaFilter?.filters?.find((filter)=>{
                            return filter.key === form.key;
                        })?.terms.find((term)=>{
                            return term === field.value;
                        });
                        if (filterMatch) {
                            defaultVal = field.label ?? '';
                        }
                    });
                });
                if (defaultVal.length === 0) {
                    const defaultField = form.formDefinition?.fieldGroups[0].fields[0];
                    defaultVal = defaultField.label ?? '';
                }
            }
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(Select, {
                    items: form.formDefinition.fieldGroups?.length ? form.formDefinition.fieldGroups[0].fields?.map((field)=>{
                        return {
                            label: field.label ?? null,
                            value: field.key
                        };
                    }) : [],
                    onChange: (event)=>handleSelectFilterSubmit(event, form),
                    dataTestId: 'searchSelect',
                    value: defaultVal,
                    height: "40px"
                })
            });
        }
        let selected = [];
        if (form.formDefinition.fieldGroups) {
            form.formDefinition.fieldGroups[0].fields.forEach((field)=>{
                criteriaFilter?.filters?.find((filter)=>{
                    return filter.key === form.key;
                })?.terms.forEach((term)=>{
                    term === field.key && selected.push(field);
                });
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                index > 0 && /*#__PURE__*/ _jsx(GridItem, {
                    children: /*#__PURE__*/ _jsx(Divider, {
                        orientation: "vertical",
                        sx: classes['.divider']
                    })
                }),
                /*#__PURE__*/ _jsx(GridItem, {
                    id: form.key,
                    onClick: ()=>!form?.formDefinition?.fieldGroups?.[0]?.fields?.length && handleFilterCategoryClick(form.key),
                    "data-testid": `checkboxFilter${index}`,
                    children: /*#__PURE__*/ _jsx(CheckboxMenu, {
                        options: (form?.formDefinition?.fieldGroups?.[0]?.fields && getCheckboxItems(form.formDefinition.fieldGroups[0].fields)) ?? [],
                        label: form.name,
                        onApplyFilters: (selectedOptions)=>{
                            handleFilterSubmit(form.key, selectedOptions);
                        },
                        selectedOptions: getCheckboxItems(selected) ?? [],
                        menuIcon: iconMapper(form.key)
                    })
                }, form.name)
            ]
        });
    });
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs(Grid, {
            display: 'flex',
            children: [
                filterDropdowns,
                hasMultipleFilters && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(GridItem, {
                            children: /*#__PURE__*/ _jsx(Divider, {
                                orientation: "vertical",
                                sx: classes['.divider']
                            })
                        }),
                        /*#__PURE__*/ _jsx(GridItem, {
                            children: /*#__PURE__*/ _jsx(Button, {
                                label: "clear all",
                                variant: ButtonVariant.LINKS,
                                height: '24px',
                                onClick: ()=>clearFilters(),
                                dataTestId: "clearAllButton"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
PopUpFiltersV2.displayName = 'PopupFiltersV2';
export { PopUpFiltersV2 };
